// extracted by mini-css-extract-plugin
export default {"body_home":"HomePage_body_home__eoqkM","body_left":"HomePage_body_left__5at7R","body_right":"HomePage_body_right__GGc54"};